/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".featurette-divider[_ngcontent-%COMP%]{margin:3rem 0}.featurette-heading[_ngcontent-%COMP%]{font-weight:250;line-height:1;letter-spacing:-.05rem;font-size:25px}"];
export { styles as styles };

